import { render, staticRenderFns } from "./NdCpuHistory.vue?vue&type=template&id=4342a85f&"
import script from "./NdCpuHistory.vue?vue&type=script&lang=js&"
export * from "./NdCpuHistory.vue?vue&type=script&lang=js&"
import style0 from "./NdCpuHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports